/* EPOMAKER search dialog (snippets/ep-search-dialog.liquid).
   Function ported from the Linsoul search (assets/ls-search.js in the Linsoul theme):
   Shopify predictive search rendered by sections/ep-predictive-search.liquid, category rail,
   keyboard listbox, highlighted matches, load more, Cmd/Ctrl+K. Copy comes from #eps-strings.
   Opens from [data-eps-open] and Minimog's [data-open-search-popup] triggers. */
(function () {
  'use strict';
  if (window.EpSearch) return;

  const host = document.getElementById('ep-search');
  const dialog = document.getElementById('eps-dialog');
  if (!host || !dialog || typeof dialog.showModal !== 'function') return;

  const $ = (sel, root = host) => root.querySelector(sel);
  const $$ = (sel, root = host) => Array.from(root.querySelectorAll(sel));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  const fill = (tpl, vars) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));

  let T = {};
  try { T = JSON.parse(document.getElementById('eps-strings').textContent); } catch (e) { T = {}; }

  const input = $('#eps-input');
  const inner = $('.eps-inner', dialog);
  const resultsEl = $('#eps-results');
  const sideEl = $('#eps-side');
  const idleTpl = document.getElementById('eps-idle');
  const idle = idleTpl ? idleTpl.content.querySelector('[data-eps-data]') : null;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const CATS = ['all', 'products', 'collections', 'guides'];

  const STEP = 8;
  const cache = new Map();
  let query = '';
  let category = 'all';
  let limit = STEP;
  let current = idle;
  let failed = false;
  let options = [];
  let active = -1;
  let timer = 0;
  let controller = null;
  let composing = false;
  let returnFocus = null;
  let closing = false;
  let anim = null;
  let prevOverflow = '';
  let revision = 0;

  /* ── data ── */
  function fields() {
    let f = 'title,product_type,vendor,variants.sku,variants.title,tag';
    if (dialog.dataset.searchByBody === 'true') f += ',body';
    return f;
  }
  function suggestURL(q) {
    const p = new URLSearchParams();
    p.set('q', q);
    p.set('section_id', 'ep-predictive-search');
    p.set('resources[type]', 'product,collection,page,article,query');
    p.set('resources[limit]', '10');
    p.set('resources[limit_scope]', 'each');
    p.set('resources[options][unavailable_products]', dialog.dataset.unavailable || 'last');
    p.set('resources[options][fields]', fields());
    return (dialog.dataset.suggestUrl || '/search/suggest') + '?' + p.toString();
  }
  function searchURL(q) {
    return (dialog.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }
  async function fetchResults(q) {
    const key = norm(q);
    if (cache.has(key)) return cache.get(key);
    controller?.abort();
    controller = new AbortController();
    const res = await fetch(suggestURL(q), { signal: controller.signal, credentials: 'same-origin' });
    if (!res.ok) throw new Error('Search request failed: ' + res.status);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const data = doc.querySelector('[data-eps-data]');
    if (!data) throw new Error('Search response missing results');
    cache.set(key, data);
    return data;
  }
  function group(src, key) {
    const list = src?.querySelector('[data-group="' + key + '"]');
    return list ? Array.from(list.children) : [];
  }
  function highlight(root, q) {
    const tokens = norm(q).split(' ').filter(Boolean);
    if (!tokens.length) return;
    const re = new RegExp('(' + tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'ig');
    root.querySelectorAll('[data-highlight]').forEach((el) => {
      el.innerHTML = el.textContent.split(re).map((part, i) => (i % 2 ? '<mark>' + esc(part) + '</mark>' : esc(part))).join('');
    });
  }

  /* ── render ── */
  function clearActive() {
    active = -1;
    input.removeAttribute('aria-activedescendant');
  }

  function render() {
    clearActive();
    const isIdle = !query.trim();
    const src = isIdle ? idle : current;
    const found = { products: group(src, 'products'), collections: group(src, 'collections'), guides: group(src, 'guides') };

    /* typed a page/manual word (no product title matches) → pages first */
    const tokens = norm(query).split(' ').filter((t) => t.length >= 3);
    const hit = (li) => {
      const text = norm((li.querySelector('[data-highlight]')?.textContent || '') + ' ' + (li.querySelector('small')?.textContent || ''));
      return tokens.some((t) => text.includes(t));
    };
    const pagesLead = !isIdle && tokens.length > 0 && !found.products.some(hit) && (found.guides.some(hit) || found.collections.some(hit));

    let chosen = [category];
    if (category === 'all') {
      if (pagesLead) chosen = ['guides', 'collections', 'products'];
      else chosen = found.products.length ? ['products', 'guides'] : ['guides', 'collections'];
      if (isIdle) chosen = ['products'];
    }
    const names = { products: T.products || 'Products', collections: T.collections || 'Collections', guides: T.guides || 'Manuals & help' };
    const selected = chosen.map((key) => ({ key, list: found[key] })).filter((x) => x.list.length);
    const heading = category === 'all'
      ? (isIdle ? (T.idleHeading || 'Popular right now') : (found.products.length && !pagesLead ? names.products : (T.pagesHeading || 'Pages & manuals')))
      : names[category];

    const total = found.products.length + found.collections.length + found.guides.length;
    /* no results: the empty message speaks for itself, no list heading or "0 matches" */
    $('#eps-results-heading').textContent = !isIdle && !selected.length ? '' : heading;
    $('#eps-count').textContent = isIdle || failed || !total ? '' : fill(T.matches || '[n] matches', { n: total });

    resultsEl.innerHTML = '';
    let index = 0;
    for (const { key, list } of selected) {
      const section = document.createElement('section');
      section.className = 'eps-group eps-group--' + key;
      section.setAttribute('role', 'group');
      section.setAttribute('aria-label', names[key]);
      if (selected.length > 1) {
        const h = document.createElement('h4');
        h.className = 'eps-group__head';
        h.textContent = names[key];
        section.appendChild(h);
      }
      const ul = document.createElement('ul');
      ul.className = 'eps-list' + (key === 'products' ? ' eps-list--products' : '');
      ul.setAttribute('role', 'presentation');
      const cap = key === 'products' ? limit : Math.max(limit, 6);
      list.slice(0, cap).forEach((li) => {
        const clone = li.cloneNode(true);
        const opt = clone.querySelector('[role="option"]');
        if (opt) opt.id = 'eps-opt-' + index++;
        ul.appendChild(clone);
      });
      section.appendChild(ul);
      resultsEl.appendChild(section);
    }
    if (!isIdle) highlight(resultsEl, query);

    resultsEl.setAttribute('aria-busy', 'false');
    options = $$('[role="option"]', resultsEl);
    input.setAttribute('aria-expanded', String(dialog.open && options.length > 0));

    const empty = $('#eps-empty');
    empty.hidden = options.length > 0;
    $('h3', empty).textContent = failed ? (T.failedTitle || '') : (T.emptyTitle || '');
    $('p', empty).textContent = failed ? (T.failedText || '') : (category === 'all' ? (T.emptyText || '') : (T.emptyTextCategory || ''));

    $$('#eps-cats button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.category === category)));
    $$('#eps-cats [data-count]').forEach((el) => {
      const n = found[el.dataset.count].length;
      el.textContent = isIdle || failed || !n ? '' : n;
    });

    const discovery = $('#eps-discovery');
    if (discovery) discovery.hidden = !isIdle;
    dialog.dataset.state = isIdle ? 'idle' : 'typing';

    const more = $('#eps-more');
    more.hidden = !selected.some((x) => x.list.length > (x.key === 'products' ? limit : Math.max(limit, 6)));
    more.textContent = chosen.length === 1 && chosen[0] === 'products' ? (T.moreProducts || '') : (T.moreResults || '');

    renderSide(src, isIdle);

    $('#eps-status').textContent = isIdle
      ? (T.statusIdle || '')
      : failed ? (T.failedTitle || '') : fill(T.statusResults || '', { n: total, shown: options.length, heading });

    const all = $('#eps-all');
    all.href = isIdle ? all.dataset.browseHref : searchURL(query);
    $('[data-view-label]', all).textContent = isIdle ? (T.browseAll || '') : (T.viewAll || '');
  }

  function renderSide(src, isIdle) {
    sideEl.innerHTML = '';
    const side = src?.querySelector('[data-side]');
    if (side) sideEl.append(...Array.from(side.children).map((n) => n.cloneNode(true)));
    sideEl.querySelectorAll('[data-label="suggested"]').forEach((h) => { h.textContent = T.suggested || ''; });
    if (!isIdle && !sideEl.querySelector('[data-explore]')) {
      const fallback = idle?.querySelector('[data-side] [data-explore]');
      if (fallback) sideEl.appendChild(fallback.cloneNode(true));
    }
    sideEl.hidden = !sideEl.textContent.trim();
  }

  function run(rev) {
    const q = query;
    if (!q.trim()) { failed = false; render(); return; }
    resultsEl.setAttribute('aria-busy', 'true');
    fetchResults(q)
      .then((data) => { if (rev !== revision) return; current = data; failed = false; render(); })
      .catch((err) => { if (err.name === 'AbortError' || rev !== revision) return; current = null; failed = true; render(); });
  }

  function setQuery(value, immediate = false) {
    query = String(value).slice(0, 120);
    input.value = query;
    limit = STEP;
    $('#eps-clear').hidden = !query.trim();
    clearActive();
    const rev = ++revision;
    clearTimeout(timer);
    timer = 0;
    const discovery = $('#eps-discovery');
    if (discovery) discovery.hidden = !!query.trim();
    dialog.dataset.state = query.trim() ? 'typing' : 'idle';
    if (immediate || cache.has(norm(query))) { run(rev); return; }
    resultsEl.setAttribute('aria-busy', 'true');
    timer = setTimeout(() => { timer = 0; if (rev === revision) run(rev); }, 150);
  }
  function flush() {
    if (timer) { clearTimeout(timer); timer = 0; run(revision); }
  }
  function resetScroll() {
    $('#eps-scroller').scrollTop = 0;
    $('#eps-shell').scrollTop = 0;
  }
  function changeCategory(next) {
    if (!CATS.includes(next)) return;
    category = next;
    limit = STEP;
    render();
    resetScroll();
  }
  function choose(i) {
    if (!options.length) return;
    active = Math.max(0, Math.min(i, options.length - 1));
    options.forEach((o, n) => o.setAttribute('aria-selected', String(n === active)));
    input.setAttribute('aria-activedescendant', options[active].id);
    options[active].scrollIntoView({ block: 'nearest' });
  }

  /* ── open / close ── */
  function animate(leave, done) {
    anim?.cancel?.();
    anim = null;
    let called = false;
    const finish = () => { if (called) return; called = true; done?.(); };
    if (reduced.matches || !inner.animate) return finish();
    const ms = leave ? 140 : 240;
    const frames = [{ opacity: 0, transform: 'translateY(10px) scale(.99)' }, { opacity: 1, transform: 'none' }];
    anim = inner.animate(leave ? frames.slice().reverse() : frames, { duration: ms, easing: leave ? 'cubic-bezier(.4,0,1,1)' : 'cubic-bezier(.23,1,.32,1)', fill: leave ? 'forwards' : 'none' });
    anim.finished.then(finish).catch(() => {});
    /* never let closing depend on the animation event (paused in background tabs) */
    setTimeout(finish, ms + 120);
  }
  const triggers = () => $$('[data-eps-open],[data-open-search-popup]', document);
  function updateTriggers() {
    triggers().forEach((el) => el.setAttribute('aria-expanded', String(dialog.open && !closing)));
  }

  function open(trigger, value) {
    if (value !== undefined) { category = 'all'; setQuery(value, true); resetScroll(); }
    if (dialog.open && !closing) { input.focus({ preventScroll: true }); return; }
    window.dispatchEvent(new CustomEvent('ep:overlay-opening', { detail: { kind: 'search' } }));
    const visible = (el) => el && el.isConnected && el.getClientRects().length;
    returnFocus = visible(trigger) ? trigger : triggers().find(visible) || document.activeElement;
    prevOverflow = document.documentElement.style.overflow;
    closing = false;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    animate(false);
    render();
    updateTriggers();
    input.focus({ preventScroll: true });
  }

  function close({ restore = true, immediate = false } = {}) {
    if (!dialog.open) return;
    const focus = returnFocus;
    const finish = () => {
      dialog.close();
      anim?.cancel?.();
      closing = false;
      returnFocus = null;
      document.documentElement.style.overflow = prevOverflow;
      input.setAttribute('aria-expanded', 'false');
      updateTriggers();
      if (restore && focus?.isConnected && focus.getClientRects().length) focus.focus({ preventScroll: true });
    };
    if (immediate || closing) { anim?.cancel?.(); finish(); return; }
    closing = true;
    animate(true, finish);
  }

  /* ── events ── */
  dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
  dialog.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || composing || e.isComposing) return;
    e.preventDefault();
    e.stopPropagation();
    close();
  });
  dialog.addEventListener('click', (e) => {
    if (e.target !== dialog) return;
    const r = inner.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
  });

  input.addEventListener('compositionstart', () => { composing = true; clearTimeout(timer); timer = 0; revision++; });
  input.addEventListener('compositionend', () => { composing = false; setQuery(input.value); });
  input.addEventListener('input', () => { if (!composing) setQuery(input.value); });
  input.addEventListener('keydown', (e) => {
    if (composing || e.isComposing) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      flush();
      const down = e.key === 'ArrowDown';
      choose(active < 0 ? (down ? 0 : options.length - 1) : active + (down ? 1 : -1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (active >= 0 && options[active]) options[active].click();
      else if (query.trim()) submit();
    }
  });

  function submit() {
    clearTimeout(timer);
    const url = searchURL(query);
    close({ restore: false, immediate: true });
    window.location.href = url;
  }
  $('#eps-form').addEventListener('submit', (e) => { e.preventDefault(); if (query.trim()) submit(); });
  const reset = () => { category = 'all'; setQuery('', true); resetScroll(); input.focus(); };
  $('#eps-clear').addEventListener('click', reset);
  $('#eps-reset').addEventListener('click', reset);
  $('#eps-more').addEventListener('click', () => {
    const before = options.length;
    limit += 6;
    render();
    if (!$('#eps-more').hidden) $('#eps-more').focus({ preventScroll: true });
    else options[before]?.focus({ preventScroll: true });
  });

  const viewAll = $('#eps-all');
  viewAll.dataset.browseHref = viewAll.getAttribute('href');

  host.addEventListener('click', (e) => {
    if (e.target.closest('[data-eps-close]')) { close(); return; }
    const cat = e.target.closest('[data-category]');
    if (cat) { changeCategory(cat.dataset.category); return; }
    const q = e.target.closest('[data-query]');
    if (q) { open(null, q.dataset.query); input.focus({ preventScroll: true }); return; }
    if (e.target.closest('a[href]')) close({ restore: false, immediate: true });
  });

  /* capture phase: runs before any other delegate on the same triggers */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-eps-open],[data-open-search-popup]');
    if (!trigger || host.contains(trigger)) return;
    e.preventDefault();
    open(trigger);
  }, true);
  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && !e.altKey && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      open(triggers().find((el) => el.getClientRects().length));
    }
    /* keyboard: Enter / Space on a non-button trigger (the header field is a span) */
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest?.('[data-eps-open]:not(button):not(a)')) {
      e.preventDefault();
      open(e.target.closest('[data-eps-open]'));
    }
  });
  document.addEventListener('error', (e) => {
    const img = e.target;
    if (img.tagName === 'IMG' && img.closest('.eps-row__photo')) img.hidden = true;
  }, true);

  window.MinimogEvents?.subscribe?.(window.MinimogTheme?.pubSubEvents?.openCartDrawer, () => close({ restore: false, immediate: true }));

  /* shortcut hint in the header field: ⌘K on Apple devices, Ctrl K elsewhere */
  if (!/Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent)) {
    document.querySelectorAll('.eph-search__kbd').forEach((el) => { el.textContent = 'Ctrl K'; });
  }

  render();
  updateTriggers();

  window.EpSearch = {
    open: (value, trigger) => open(trigger, value),
    close: () => close({ immediate: true }),
    setCategory: changeCategory,
    state: () => ({ query, category, active, shown: options.length, open: dialog.open, failed })
  };
})();
